// JOBE-0098.3: pure-function variant selector for the open palette
// panel. Mirrors the JOBE-0044.14 pickVariant pattern: a small,
// table-driven selector takes the parsed query plus the raw input and
// returns one of the four open-panel state IDs documented in
// JOBE-0098 §Six states. The collapsed state (state 1) is handled by
// the parent's `open` flag, not here. State 6 (Ask) is stubbed in
// Phase 3 — pickState always returns one of the Find states.
export function pickState(parsed, input) {
  if (!input || !input.trim()) return 'empty';
  const hasPredicates = parsed && parsed.predicates && parsed.predicates.length > 0;
  const fuzzy = parsed ? parsed.fuzzyFragment : null;
  if (hasPredicates && fuzzy) return 'mixed';
  if (hasPredicates) return 'predicate';
  return 'plain';
}
